import { useRef, useState } from "react";
import styled from "styled-components";

import SHADOWS from "components/atoms/shadows";
import COLORS from "components/atoms/colors";

import Option from "types/Option";
import useDropdown from "hooks/useDropdown";

import { ReactComponent as IconArrow } from "assets/images/common/arrow-up.svg";

interface Props {
  options: Option[];
  onChange: (optionId: number) => void;
}

// 상품상세 - 사이즈 옵션 셀렉트 박스
const SelectSize = ({ options, onChange }: Props) => {
  const element = useRef(null);
  const [show, setShow] = useDropdown(element);
  const [displayName, setDisplayName] = useState(options[0]?.size);

  const handleClick = ({ id, size }: Option) => {
    setShow(false);
    onChange(id);
    setDisplayName(size);
  };

  if (options.length === 0) return null;

  return (
    <div ref={element} className="relative flex flex-col justify-center">
      <BtnSelect onClick={() => setShow(!show)} active={show}>
        {displayName}/mm
        <IconArrow transform="rotate(180)" />
      </BtnSelect>
      {show && (
        <OptionWrapper>
          {options.map((option) => (
            <OptionItem key={option.id} onClick={() => handleClick(option)}>
              {option.size}/mm
            </OptionItem>
          ))}
        </OptionWrapper>
      )}
    </div>
  );
};

const BtnSelect = styled.button<{ active: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: 12px;
  border-radius: 4px;
  border: 1px solid ${COLORS.black["100%"]};
  color: ${COLORS.black["100%"]};
`;

const OptionWrapper = styled.ul`
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  min-width: 100%;
  z-index: 1;
  background: #ffffff;
  box-shadow: ${SHADOWS.card};
  border-radius: 4px;
  overflow: hidden;
`;

const OptionItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background-color: ${COLORS.white["60%"]};
  }
`;

export default SelectSize;
